export const items = [
  'Modify or copy the materials;',
  'Use the materials for any commercial purpose, or for any public display (commercial or non-commercial);',
  'Attempt to decompile or reverse engineer any software contained on CyberActive’s web site;',
  'Remove any copyright or other proprietary notations from the materials;',
  'Transfer the materials to another person or “mirror” the materials on any other server.',
];
